import React, {Component} from 'react';
import PropTypes from "prop-types";
import _ from "lodash";

import Table from "react-bootstrap/Table";
import TableRow from "./TableRow";
import TableCell from "./TableCell";
import TableHeader from "./TableHeader";

import {TEXT} from '../../utilities/strings';
import {COLUMN_SHAPE} from "../../utilities/columns";

/**
 * Component to render the selectable table
 * This table allows a user to select a row by clicking or Ctrl+Clicking
 *
 * @example
 * <SelectionTable
 *   type={sectionType}
 *   nationalData={this.props.nationalData}
 *   selectedLocation={this.props.selectedState}
 *   comparisonLocation={this.props.comparisonState}
 *   columns={Utils.getSelectionColumns(this.props.selectedCost)}
 *  />
 */
export default class SelectionTable extends Component {

  static propTypes = {
    caption: PropTypes.string,
    type: PropTypes.oneOf(['state', 'county']),
    columns: PropTypes.arrayOf(COLUMN_SHAPE),
    nationalData: PropTypes.array,
    primaryLocation: PropTypes.object,
    selectedLocation: PropTypes.object,
    comparisonLocation: PropTypes.object
  };

  renderDefaultSelectedRow = () => (
    <TableRow>
      <th scope="row">{this.props.type === 'state' ? TEXT.selected_state : TEXT.selected_county}</th>
      <td colSpan={3}><em>{TEXT.selected_prompt}</em></td>
    </TableRow>
  )

  renderDefaultComparisonRow = () => (
    <TableRow>
      <th scope="row">{this.props.type === 'state' ? TEXT.comparison_state : TEXT.comparison_county}</th>
      <td colSpan={3}><em>{TEXT.comparison_prompt}</em></td>
    </TableRow>
  )

  renderLocationRow = (model) => (
    <TableRow>
      {_.map(this.props.columns, col => <TableCell key={col.field} column={col} value={model}/>)}
    </TableRow>
  )

  render() {
    const {nationalData, primaryLocation, selectedLocation, comparisonLocation} = this.props;

    const nationalRecord = _.first(nationalData);
    const nationalRow = nationalRecord && this.renderLocationRow(nationalRecord);
    const primaryRow = primaryLocation && this.renderLocationRow(primaryLocation);
    const selectedRow = selectedLocation ? this.renderLocationRow(selectedLocation) : this.renderDefaultSelectedRow();
    const comparisonRow = comparisonLocation ? this.renderLocationRow(comparisonLocation) : this.renderDefaultComparisonRow();

    return (
      <Table
        size="sm"
        hover={false}
        bordered={false}
        striped={false}
        responsive={true}>

        <caption className="caption-bottom">{this.props.caption}</caption>

        <thead>
        <TableHeader columns={this.props.columns}/>
        </thead>

        <tbody>
        {nationalRow}
        {primaryRow}
        {selectedRow}
        {comparisonRow}
        </tbody>

      </Table>
    )
  }
}
